import { Alert } from './Alert';

export type { TypeAlertProps } from './types';
export default Alert;
